import React from 'react'
import Iframe from 'react-iframe'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import config from '../Config';

export const WikiIssuingSec = () => {
  return (
    <>
        <section className='wiki-iframebox'>
        <img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`}  alt="" className="blue-dots2" />
            <Container>
                <Row>
                    <Col xs lg="12" className='wiki-iframe'>
                        <Iframe url="https://wiki.tcbpay.com/app/page/14oow9COzPw5F8AFmKQ4eUxAwopfw1hMTYZJ4aesxONU?p=1-FCVNEqdUR3Ew4bR0RS1zmXzEU1tqmN3&wikis=1-FCVNEqdUR3Ew4bR0RS1zmXzEU1tqmN3,1xAoDlosTZwdEtdo0puWzRnhV4j-dUmaR"
                            width="100%"
                            height="720px"
                            id=""
                            className=""
                            display="block"
                            position="relative" />
                    </Col>
                </Row>
            </Container>
        </section>
    </>
  )
}
